export default __webpack_public_path__ + "static/media/ic_arrow_long_pink_orange.f8eaab23.svg";